
import {React , useEffect} from 'react';
import AOS from 'aos';
import { Navigate, Route, Routes } from 'react-router-dom';

import routes from './pages';
import Page404 from './pages/404';
import Header from './components/header/Header';
import Login from './pages/Auth/Login';
import EmailVerificationPage from './pages/Auth/EmailVerificationPage/EmailVerificationPage';
import ForgotPassword from './pages/Auth/ForgotPassword/ForgotPassword';
import ResetPasswordPage from './pages/Auth/ResetPassword/ResetPassword';
import ECommerce from './pages/Dashboard/Dashboard/ECommerce';
import DefaultLayout from './components/Dashboard/DefaultLayout';

import PresistLogin from './components/PresistLogin.jsx';
import Protected from './pages/Auth/Protected/Protected.jsx';
import SignUp from './pages/Dashboard/Authentication/SignUp.tsx';
import PageTitle from './components/Dashboard/PageTitle.tsx';
import CreateArticle from './pages/Dashboard/CreateArticle/CreateArticle.tsx';
import ArticleSinglePage from './pages/Dashboard/ArticleSinglePage/ArticleSinglePage.jsx';
import Promotion from './pages/Dashboard/Promotions/Promotion.jsx';
import PromotionsPageSettings from './pages/Dashboard/Promotions/PromotionsPageSettings.jsx';
import FormElements from './pages/Dashboard/Form/FormElements.tsx';
import Alerts from './pages/Dashboard/UiElements/Alerts.tsx';
import Profile from './pages/Dashboard/Profile.jsx';
import FormLayout from './pages/Dashboard/Form/FormLayout.tsx';
import Tables from './pages/Dashboard/Tables.tsx';
import { Settings } from 'lucide-react';
import Chart from './pages/Dashboard/Chart.tsx';
import SignIn from './pages/Dashboard/Authentication/SignIn.tsx';
// import { io } from 'socket.io-client';
import SingleMatchDetails from './pages/Dashboard/SingleMatchDetails/SingleMatchDetails.jsx';
import Deposit from './pages/Dashboard/Deposit/Deposit.jsx';
import Withdraw from './pages/Dashboard/Withdraw/Withdraw.jsx';
import WithdrawRequests from './pages/Dashboard/Withdraw/WithdrawRequests.jsx';
import DepositRequests from './pages/Dashboard/Deposit/DepositRequests.jsx';
import CreateMatch from './pages/Dashboard/Dashboard/CreateMatch.tsx';
import Transactions from './pages/Dashboard/Transactions/Transactions.jsx';
import "./tailwindCSS.css" 
import AppliedMatches from './pages/Dashboard/AppliedMatches/AppliedMatches.jsx';
import Home01 from './pages/Home01.jsx';
import PublicRoute from './components/PublicRoute/PublicRoute.jsx';

// const Socket = io("http://localhost:5000/")

const Layout = ({ children }) => (
    <>
      <Header />
      {children}
    </>
  );

  function DashboardRoutes() {
    return (
      <DefaultLayout>
        <Routes>
          <Route element={<Protected allowedRoles={["admin", "user"]} />}>
            <Route
              path="/"
              element={
                <>
                  <PageTitle title=" Dashboard " />
                  <ECommerce />
                </>
              }
            />
      <Route element={<Protected allowedRoles={["admin"]} />}>
              <Route
              path="/createMatch"
              element={
                <>
                  <PageTitle title="Match Creation " />
                  <CreateMatch />
                </>
              }
            />
            </Route>

            <Route
              path="/create-article"
              element={
                <>
                  <PageTitle title="Create Article" />
                  <CreateArticle />
                </>
              }
            />
            
            <Route
              path="/list-articles/"
              element={
                <>
                  <PageTitle title="List Article" />
                  {/* <ListArticles /> */}
                </>
              }
            />
            <Route
              path="/list-articles/:string"
              element={
                <>
                  <PageTitle title="Article" />
                  <ArticleSinglePage />
                </>
              }
            />
        
          
        
            <Route
              path="/profile"
              element={
                <>
                  <PageTitle title="Profile " />
                  <Profile />
                </>
              }
            />
  
            <Route
              path="/forms/form-layout"
              element={
                <>
                  <PageTitle title="Form Layout " />
                  <FormLayout />
                </>
              }
            />
          
            <Route
              path="/settings"
              element={
                <>
                  <PageTitle title="Settings " />
                  <Settings />
                </>
              }
            />
             <Route
              path="/deposit"
              element={
                <>
                  <PageTitle title="Deposit funds " />
                  <Deposit />
                </>
              }
            />
             <Route element={<Protected allowedRoles={["admin"]} />}>
              <Route
              path="/depositRequests"
              element={
                <>
                  <PageTitle title="Deposit requests " />
                  <DepositRequests />
                </>
              }
            />
            </Route>
                  <Route
              path="/withdraw"
              element={
                <>
                  <PageTitle title="Withdraw funds " />
                  <Withdraw />
                </>
              }

            />
             <Route
              path="/transactions"
              element={
                <>
                  <PageTitle title="transactions " />
                  <Transactions />
                </>
              }
              
            />
               <Route element={<Protected allowedRoles={["admin"]} />}>
              <Route
              path="/withdrawRequests"
              element={
                <>
                  <PageTitle title="Withdraw requests " />
                  <WithdrawRequests />
                </>
              }
            />
            </Route>
          
            <Route
              path="/matchDetails/:string"
              element={
                <>
                  <PageTitle title="Match Details " />
                  <SingleMatchDetails />
                </>
              }
            />
              <Route
              path="/myMatches"
              element={
                <>
                  <PageTitle title="My Matches " />
                  <AppliedMatches />
                </>
              }
            />
          
          </Route>
        </Routes>
      </DefaultLayout>
    );
  }

function App() {
  

    useEffect(() => {
        AOS.init({
          duration : 2000
        }); 
      }, []);

    return (
        <>

            {/* <Header /> */}

            <Routes>

            {/* <Route path="/" element={<Layout />}> */}
              {/* <Route element={<PublicRoute/>}> */}

             
                {
                    routes.map((data,idx) => (
                        <Route key={idx} path={data.path} element={data.component} exact />
                    ))
                }
                {/* </Route> */}
                <Route path="/" element={<Home01/>} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<SignUp />} />
        {/* <Route element={<AuthLayout />}> */}
        <Route path="forgotPassword" element={<ForgotPassword />} />
        <Route path="resetPassword/:token" element={<ResetPasswordPage />} />
        {/* </Route> */}
        <Route element={<PresistLogin />}>
          <Route path="dashboard/*" element={<DashboardRoutes />} />
        <Route path="verifyEmail" element={<EmailVerificationPage />} />
        </Route>
                <Route path='*' element={<Page404 />} />
            </Routes>

    
        </>
    );
}

export default App;
